import React from "react";
import "./style/confirmationModal.scss";
import { Button, Modal } from "react-bootstrap";
import { useStrings } from "../../../hooks/useStrings";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  message?: string;
  title?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  message,
  title,
}) => {
  const S = useStrings();
  const displayMessage = message ?? S.CONFIRMATION_MODAL.DEFAULT_MESSAGE;
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-confirmation"
    >
      <Modal.Body>
        <div className="modal-status-icon text-danger">
          <i className="bi bi-exclamation-triangle"></i>
        </div>
        {title && <h5>{title}</h5>}
        <p>{displayMessage}</p>

        <div className="modal-button">
          <Button
            variant="outline-secondary"
            className="btn-default"
            onClick={onHide}
          >
            {S.COMMON.NO}
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {S.COMMON.YES}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;

